import { Card, CardContent } from "@/components/ui/card";
import type { AnswerFeedbackSummary } from "@/lib/api";

import { AnswerFeedbackExplorer } from "./answer-feedback-explorer";

interface Props {
  summary: AnswerFeedbackSummary;
}

/**
 * Teams' "was this answer helpful?" ratings. Kept apart from the per-part
 * accuracy figures above it on purpose: those ask "was this the right part?",
 * these rate the whole reply, so mixing the two counts would mean nothing.
 */
export function AnswerFeedbackSection({ summary }: Props) {
  const stats = [
    { label: "Answer ratings", value: String(summary.total) },
    { label: "Helpful", value: String(summary.helpful) },
    { label: "Not helpful", value: String(summary.unhelpful) },
    { label: "Helpful rate", value: `${Math.round(summary.helpful_pct)}%` },
  ];

  return (
    <section className="border-border space-y-4 border-t pt-8">
      <div>
        <h2 className="font-heading text-primary text-lg font-bold">Answer ratings (Teams)</h2>
        <p className="text-muted text-xs">
          Thumbs up or down on a whole Teams reply — whether the answer helped, not whether a part
          was right.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {stats.map((stat) => (
          <Card key={stat.label}>
            <CardContent className="py-4">
              <p className="text-muted text-xs">{stat.label}</p>
              <p className="text-primary text-2xl font-bold">{stat.value}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <AnswerFeedbackExplorer />
    </section>
  );
}
